import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPartyDetailMain } from './modules/ui/Main';

const PartyDetailPage = (
  <SuspensePage>
    <PagesPartyDetailMain />
  </SuspensePage>
);

export default PartyDetailPage;
